import React from "react";

export default function PrivacyPolicy() {
    return (
        <main className="relative text-light overflow-x-hidden bg-[#0A0E14] py-32 px-4">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl sm:text-5xl font-semibold text-center mb-10 bg-clip-text text-transparent bg-gradient-to-r from-[#A78BFA] via-[#7C3AED] to-[#22D3EE] py-4">
                    Privacy Policy – 4AI S.r.l.
                </h1>

                <div className="space-y-10 bg-white/5 border border-dark-100 rounded-3xl p-8 backdrop-blur shadow-xl">
                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-[#A78BFA]">1. Titolare del trattamento</h2>
                        <p className="text-gray-300 leading-relaxed">
                            Il titolare del trattamento dei dati personali è <strong>4AI S.r.l.</strong>, con sede legale in Via
                            Minturno 61, Roma. PEC: <strong>4ai@legalmail.it</strong>, email: <strong>4ai.srl@gmail.com</strong>.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-[#A78BFA]">2. Dati raccolti</h2>
                        <p className="text-gray-300 leading-relaxed mb-2">Raccogliamo i seguenti dati tramite il form di contatto:</p>
                        <ul className="list-disc list-inside text-gray-300 space-y-1">
                            <li>Nome e cognome</li>
                            <li>Email</li>
                            <li>Messaggio di richiesta contatto</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-[#A78BFA]">3. Finalità del trattamento</h2>
                        <ul className="list-disc list-inside text-gray-300 space-y-1">
                            <li>Rispondere alla richiesta di contatto</li>
                            <li>Organizzare e gestire l'incontro per la demo del prodotto 2Sequel</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-[#A78BFA]">4. Base giuridica</h2>
                        <p className="text-gray-300 leading-relaxed">
                            Il trattamento si basa sul <strong>consenso espresso dall’utente</strong> al momento dell’invio del form,
                            ai sensi dell’art. 6, par. 1, lett. a) del GDPR.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-[#A78BFA]">5. Modalità di trattamento</h2>
                        <p className="text-gray-300 leading-relaxed">
                            I dati sono trattati con strumenti elettronici e cartacei in modo da garantirne sicurezza e riservatezza,
                            adottando misure tecniche e organizzative adeguate.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-[#A78BFA]">6. Conservazione dei dati</h2>
                        <p className="text-gray-300 leading-relaxed">
                            I dati saranno conservati solo per il tempo necessario a gestire la richiesta di contatto e comunque non
                            oltre <strong>12 mesi</strong>.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-[#A78BFA]">7. Comunicazione a terzi</h2>
                        <p className="text-gray-300 leading-relaxed">
                            I dati non saranno ceduti a terzi, salvo fornitori di servizi strettamente necessari per gestire le
                            richieste (es. piattaforme email o CRM).
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-[#A78BFA]">8. Diritti dell’utente</h2>
                        <p className="text-gray-300 leading-relaxed mb-2">L’utente può esercitare i diritti previsti dagli articoli 15-22 del GDPR:</p>
                        <ul className="list-disc list-inside text-gray-300 space-y-1">
                            <li>Accesso ai dati personali</li>
                            <li>Rettifica di dati inesatti o incompleti</li>
                            <li>Cancellazione (“diritto all’oblio”)</li>
                            <li>Limitazione del trattamento</li>
                            <li>Opposizione al trattamento</li>
                            <li>Portabilità dei dati</li>
                        </ul>
                        <p className="text-gray-300 mt-3">Per esercitare tali diritti, scrivere a <strong>support@4aitech.it</strong>.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-[#A78BFA]">9. Reclamo all’Autorità di
                            controllo</h2>
                        <p className="text-gray-300 leading-relaxed">
                            L’utente ha diritto a proporre reclamo all’Autorità Garante per la protezione dei dati
                            personali, tramite il
                            {" "}
                            <a
                                href="https://www.garanteprivacy.it/"
                                className="text-[#22D3EE] hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                sito del Garante
                            </a>
                            .
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold mb-3 text-[#A78BFA]">10. Modifiche alla privacy
                            policy</h2>
                        <p className="text-gray-300 leading-relaxed">
                            Eventuali aggiornamenti di questa privacy policy saranno pubblicati su questa pagina. Si
                            consiglia di
                            consultarla periodicamente.
                        </p>
                    </section>
                </div>
            </div>
        </main>
    );
}
